module.exports = __webpack_public_path__ + "img/box_pro_five_5.58b0413a.jpg";